import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const cockpitApi = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: CROSS_API_URL }),
    reducerPath: 'api.cockpit',
    tagTypes: ['cockpit'],
    endpoints: (builder) => ({
        getCockpitData: builder.mutation<any, {
            current_range_date: string;
            comparison_range_date: string;
        }>({
            query: (body) => ({
                url: `/cockpit/`,
                method: 'POST',
                body,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            }),
        }),
    }),
});

export const {
    useGetCockpitDataMutation,
} = cockpitApi;

export default cockpitApi;
